import React from 'react';
import '../styles/layout/LandingPage.scss';
import CarousalPage from '../pages/CarousalPage';
import ClientPage from '../pages/ClientPage';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <>
      <div className="landing-page">
        <div className='logoContainer'>
          <div className="landing-page__title">
            Tecloq
          </div>
          <div className='landing-page__womenEmpowered'>
            <div className='landing-page__womenEmpowered__text'>
              AI and Data Analytics company
            </div>
            <div className='landing-page__womenEmpowered__innerBox'>
              <div className='landing-page__womenEmpowered__innerText'>
                A women-empowered
              </div>
            </div>
          </div>
          <div className='landing-page__gist'>
            Where Innovation meets diversity. <br />
            We are committed to fostering an inclusive <br /> environment that champions women in technology, <br />
            At Tecloq, we empower businesses to harness the power of data, while empowering women to lead <br /> the future of AI and analytics.
          </div>
          <Link to='/clientForm' style={{textDecoration:"none"}}>
            <div className='landing-page__forClientsBox'>
              <div className='landing-page__forClientsBox__Arrow'>
                <ArrowForwardIcon></ArrowForwardIcon>
              </div>
              <div className='landing-page__forText'>
                For clients
              </div>
            </div>
          </Link>
          <Link to='/Careers' style={{textDecoration:"none"}}>
          <div className='landing-page__forDevBox'>
            <div className='landing-page__forDevBox__Arrow'>
              <ArrowForwardIcon></ArrowForwardIcon>
            </div>
            <div className='landing-page__forText'>
              For Developers
            </div>
          </div>
          </Link>
        </div>

        <div className='gradientFeature'>
        </div>

      </div>
      <CarousalPage />
      <ClientPage/>
    </>
  );
};

export default LandingPage;